/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CapWindow = {
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly'
} as const;
export type CapWindow = typeof CapWindow[keyof typeof CapWindow];

